import { Flex, Image, Spinner } from '@chakra-ui/react';
import { apiSalesWeb } from '@shared/config';
import { apiNexpro } from '@shared/config/apiNexpro';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { createRequestId, getSessionAuth } from '../services';

export const OnboardingLayout = () => {
  const [haveRequestId, setHaveRequestId] = useState(false);
  const [haveAuthentication, setHaveAuthentication] = useState(false);

  const getRequestId = async () => {
    const requestIdSession = sessionStorage.getItem('requestId');
    if (!requestIdSession) {
      const { data } = await createRequestId();

      sessionStorage.setItem('requestId', data.requestId);

      apiSalesWeb.defaults.headers['request-id'] = data.requestId;
      setHaveRequestId(true);

      return;
    }

    setHaveRequestId(true);
    apiSalesWeb.defaults.headers['request-id'] = requestIdSession;
    return;
  };

  const getAuthentication = async () => {
    const authenticationOnSession = sessionStorage.getItem('accessToken');
    if (authenticationOnSession) {
      apiNexpro.defaults.headers.Authorization = `Bearer ${authenticationOnSession}`;
      apiSalesWeb.defaults.headers.Authorization = `Bearer ${authenticationOnSession}`;
      setHaveAuthentication(true);
      return;
    }

    const authId = sessionStorage.getItem('authId');
    const regexId = /id=([^&]+)/;
    const id = window.location.search.match(regexId)?.[1] || '';
    sessionStorage.setItem('sessionAuthId', id);

    if (window.location.search.includes('id') && authId !== id) {
      try {
        sessionStorage.setItem('authId', id);
        const { data } = await getSessionAuth(id);
        sessionStorage.setItem('accessToken', data.externalToken);
        apiNexpro.defaults.headers.Authorization = `Bearer ${data.externalToken}`;
        apiSalesWeb.defaults.headers.Authorization = `Bearer ${data.externalToken}`;
        setHaveAuthentication(true);
      } catch (error) {
        console.log(error);
      } finally {
        sessionStorage.removeItem('firstSend');
      }
    }
  };

  useEffect(() => {
    getRequestId();
    getAuthentication();
  }, []);

  return (
    <Flex maxH="100dvh" overflow="auto">
      <Flex
        width={100}
        bgImage="/images/sidebar.png"
        justifyContent="center"
        alignItems="start"
        p={4}
        display={{ base: 'none', lg: 'flex' }}
      >
        <Image src="/images/Icon.png" alt="logo" />
      </Flex>
      {haveRequestId && haveAuthentication ? (
        <Outlet />
      ) : (
        <Flex justifyContent="center" alignItems="center" w="full" h="100dvh">
          <Spinner size="xl" />
        </Flex>
      )}
    </Flex>
  );
};
